import $ from 'jquery';
import ApiService from '@/core/services/api.service';
import store from '@/core/services/store';
import {
  SET_ACL, SET_ANONYMOUS_VISIT,
  SET_CURRENT_SUBSCRIPTION, SET_USER_AVATAR,
  SET_USER_DATA, SET_USER_MENU,
  SET_WAITING_SUBSCRIPTION, RESET_USER_DATA
} from '@/core/services/store/profile.module';
import Subscription from '@/accounting/models/Subscription';
import securityUtil from '@/core/utils/security';
import HttpUtil from '@/core/utils/http';


const ProfileService = {

  initUserData() {
    const def = $.Deferred();
    const url = JsRouting.generate(ApiService.apiRoute('webapi_session_get_init_data'), {});
    store.commit(SET_ACL, []);

    ApiService.get(url).then((response) => {
      if (response.data && response.data.user) {
        store.commit(SET_USER_DATA, response.data.user);
      }
      if (response.data && response.data.current_subscription) {
        store.commit(SET_CURRENT_SUBSCRIPTION, new Subscription(response.data.current_subscription));
      }
      if (response.data && response.data.waiting_subscription) {
        store.commit(SET_WAITING_SUBSCRIPTION, new Subscription(response.data.waiting_subscription));
      }
      if (response.data && response.data.menu) {
        store.commit(SET_USER_MENU, response.data.menu);
      }
      if (response.data && response.data.avatar) {
        store.commit(SET_USER_AVATAR, response.data.avatar);
      }
      store.commit(SET_ACL, (response.data && response.data.acl) ? response.data.acl : (securityUtil.getAcl() || []));
      def.resolve(response.data);
    }).catch((error) => {
      store.dispatch(RESET_USER_DATA);
      store.commit(SET_ANONYMOUS_VISIT, true);
      HttpUtil.axiosErroDefaultHandler(error).done((errorString) => {
      });
      def.reject('User data could not get obtained');
    });

    return def;
  },

  getUserData() {
    return store.getters.userInfo;
  },

  resetUserData() {
    store.dispatch(RESET_USER_DATA);
  },
};

export default ProfileService;
